import { bearlog } from "@sillyscribe95/bear-ui-web";
import { sample } from "lodash";
import { roop } from "./keyConst";

export function getEmoji(curr, prev = "main") {
  bearlog.lug("___ curr, prev ___", curr, prev);

  const key = "maj";
  //   const

  const sjasd = {};

  //   1one
  let oneD = {
    1: "smile",
    2: "glum",
    3: "shock",
    4: "happy",
    5: "exited",
    6: "sad",
    7: "push",
  };
  oneD = roop(oneD);

  // 1push
  let asdasdp =
    //
    ["😵", "😵‍💫", "🤯", "😵‍💫", "🤠"];
  asdasdp = sample(asdasdp);
  // asdasdp = asdasdp[0];

  bearlog.lug("___ asdasdp ___", asdasdp);

  const baseEmo = {
    smile: "🙂",
    glum: "🙁",
    shock:
      //
      "🥺",
    // '😟',
    happy: "😀",
    exited: "😃",
    sad: "😢",
    push: asdasdp,
  };
  const emojiDict = roop(baseEmo);

  // 1major
  const majDict = {
    1: { color: "maj1", dict: oneD, title: "Home", chord: "Maj 1st" },
    2: { color: "min2", dict: oneD, chord: "Min 2nd" },
    3: { color: "min3", dict: oneD, chord: "Min 3rd" },
    4: { color: "maj4", dict: oneD, chord: "Maj 4th" },
    5: { color: "maj5", dict: oneD, chord: "Maj 5th" },
    6: { color: "min6", dict: oneD, chord: "Min 6th" },
    7: { color: "maj7", dict: oneD, chord: "Maj 7th" },
  };

  const minDict = {
    1: { color: "maj1", dict: oneD, title: "Home", chord: "Maj 1st" },
    2: { color: "min2", dict: oneD, chord: "Min 2nd" },
    3: { color: "min3", dict: oneD, chord: "Min 3rd" },
    4: { color: "maj4", dict: oneD, chord: "Maj 4th" },
    5: { color: "maj5", dict: oneD, chord: "Maj 5th" },
    6: { color: "min6", dict: oneD, chord: "Min 6th" },
    7: { color: "maj7", dict: oneD, chord: "Maj 7th" },
  };

  const keyDict = {
    ...roop(majDict),
    ...roop(minDict),
  }
  Object.entries(keyDict).map(mapKeys)
  function mapKeys([k, v], i){
    keyDict[k] = {
      ...v,
      number: k,
    }
  }

  const AAAAA = keyDict[curr];
  const emotion = oneD[curr];

  bearlog.lug("___ emotion ___", { 
    keyDict,
    emotion, ...AAAAA });

  const emoji = emojiDict[emotion];

  //   const { dict } = prev;
  //   const emoji = dict[prev];

  return { emoji, ...AAAAA };
}
